var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"ws-gradient-text-secondary-wrapper"},[_vm._t("default",function(){return [_vm._v(" EMPTY ")]}),(false)?_c('span',{staticClass:"ws-gradient-text"}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }